import { memo } from 'react';

import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import {
  balloonActions,
  BalloonStatus,
  selectBalloonBetAmount,
  selectBalloonCurrency,
  selectBalloonLoading,
  selectBalloonMultiplier,
  selectBalloonStatus,
} from '@/entities/balloon';
import { type CurrencyCode,formatCurrencyValue } from '@/shared/lib/currency';

interface BalloonTakeButtonProps {
  fallbackBet: number;
  fallbackCurrency: CurrencyCode;
}

export const BalloonTakeButton = memo(
  ({ fallbackBet, fallbackCurrency }: BalloonTakeButtonProps) => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectBalloonStatus);
  const multiplier = useAppSelector(selectBalloonMultiplier);
  const activeBet = useAppSelector(selectBalloonBetAmount);
  const activeCurrency = useAppSelector(selectBalloonCurrency);
  const loading = useAppSelector(selectBalloonLoading);

  const isReady = status === BalloonStatus.READY;
  const isHeating = status === BalloonStatus.HEATING;
  const isPaused = status === BalloonStatus.PAUSED;
  const isActive = isReady || isHeating || isPaused;

  const displayBet = activeBet ?? fallbackBet;
  const currency = ((activeCurrency ?? fallbackCurrency) as CurrencyCode) ?? 'TON';

  return (
    <button
      className={['balloon-panel__take', isPaused && 'balloon-panel__take--paused']
        .filter(Boolean)
        .join(' ')}
      onClick={() => {
        if (isActive) dispatch(balloonActions.take());
      }}
      disabled={!isActive || loading}>
      TAKE
      {isActive && (
        <>
          <br />
          <small style={{ fontSize: '0.6rem', opacity: 0.75 }}>
            {formatCurrencyValue(displayBet * multiplier, currency)}
          </small>
        </>
      )}
    </button>
  );
});
